export type ProviderErrorCode = 'NOT_IMPLEMENTED' | 'NOT_AUTHENTICATED' | 'INVALID_REQUEST' | 'RATE_LIMITED' | 'UNAVAILABLE' | 'UNKNOWN';

export interface ProviderError {
  code: ProviderErrorCode;
  message: string;
  retryable: boolean;
  documentationUrl?: string;
}

export const notImplementedError = (operation: string): ProviderError => ({
  code: 'NOT_IMPLEMENTED', message: `${operation} is not implemented by this provider connector.`, retryable: false,
});
